import { InterviewFactory } from './factories/interview.factory.js';

(function () {
    var interviewModule = angular.module('harriApp.interviewV2', []);

    interviewModule.factory('InterviewFactory', InterviewFactory);
})();